<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <div :class="b('form')">
      <div :class="b('group')">
        <p :class="b('label')">{{ $t("Дата и время") }}</p>
        <SharedSelect
          view="light"
          :options="displayedPeriodOptions"
          :value="selectedPeriod"
          @update:value="handlePeriod"
        />
      </div>

      <div v-if="isDepositWithdrawal" :class="b('group')">
        <p :class="b('label')">{{ $t("Тип") }}</p>
        <SharedSelect
          view="light"
          :options="displayedTypeOptions"
          :value="displayedType"
          @update:value="handleType"
        />
      </div>

      <div :class="b('group')">
        <p :class="b('label')">{{ $t("Валюта") }}</p>
        <SharedSelect
          view="light"
          :options="displayedCurrencyOptions"
          :value="displayedCurrency"
          @update:value="handleCurrency"
        />
      </div>

      <div :class="b('group')">
        <p :class="b('label')">{{ $t("Статус") }}</p>
        <SharedSelect
          view="light"
          :options="displayedStatusOptions"
          :value="displayedStatus"
          @update:value="handleStatus"
        />
      </div>
    </div>
  </div>
</template>
